import { render, staticRenderFns } from "./policyDocument.vue?vue&type=template&id=485edeae&scoped=true&lang=html"
import script from "./policyDocument.vue?vue&type=script&lang=js"
export * from "./policyDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485edeae",
  null
  
)

export default component.exports